import { render, staticRenderFns } from "./WhatsappTemplatePreview.vue?vue&type=template&id=045831ab&scoped=true"
import script from "./WhatsappTemplatePreview.vue?vue&type=script&lang=js"
export * from "./WhatsappTemplatePreview.vue?vue&type=script&lang=js"
import style0 from "./WhatsappTemplatePreview.vue?vue&type=style&index=0&id=045831ab&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "045831ab",
  null
  
)

export default component.exports